
import MainPage from './mainpage'

export default MainPage;